import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/logo-test.png");
;
import(/* webpackMode: "eager", webpackExports: ["ForgetPasswordForm"] */ "/home/vsts/work/1/s/src/app/_lib/components/ForgetPasswordForm.tsx");
